import {
  Button,
  SubNavBar,
  SubNavBarLeft,
  SubNavBarRight,
  type BadgeProps,
  type ButtonProps,
} from '@valiant/ui-shared'
import { useMemo } from 'react'

interface SubBarProps {
  buttons?: ButtonProps[]
  hideBack?: boolean
  title?: string
  headerTitle?: string
  headerImage?: string | React.ReactNode
  badges?: BadgeProps[]
}

function SubBar({ buttons = [], hideBack, title, headerTitle, headerImage, badges }: SubBarProps) {
  const leftBadges = useMemo(() => {
    return badges?.filter((badge: BadgeProps) => badge.direction === 'LEFT')
  }, [badges])

  const rightBadges = useMemo(() => {
    return badges?.filter((badge: BadgeProps) => badge.direction === 'RIGHT')
  }, [badges])

  return (
    <SubNavBar>
      <SubNavBarLeft hideBack={hideBack} title={title}>
        {headerImage ? (
          typeof headerImage === 'string' ? (
            <>
              <img
                src={headerImage}
                alt={`${headerTitle || title} logo`}
                className="w-[28px] h-[28px] rounded object-cover border border-card-border"
              />
            </>
          ) : (
            <div className="w-[28px] h-[28px] rounded object-cover border border-card-border flex items-center justify-center bg-gray-200">
              {headerImage}
            </div>
          )
        ) : null}
        {headerTitle ? <h2 className="text-2xl font-bold text-gray-900">{headerTitle}</h2> : null}
        {leftBadges?.map((badge: BadgeProps) => badge.node)}
      </SubNavBarLeft>
      <SubNavBarRight>
        {rightBadges?.map((badge: BadgeProps) => badge.node)}
        {buttons.map((button: ButtonProps) => (
          <Button
            key={button.label}
            variant={button.variant}
            onClick={button.onClick}
            className="px-5 h-7 md:h-9"
          >
            {button.icon ? button.icon : null}
            {button.label}
          </Button>
        ))}
      </SubNavBarRight>
    </SubNavBar>
  )
}

export { SubBar }
